import { take, put, call, fork } from "redux-saga/effects"
import { authRequest } from "src/engine/modules/authRequest"
import env from "src/env"
import { showToast } from "@infotech/uikit-toasts"

import { creators } from "src/engine/modules/entity/actions"
import eventModel from "src/models/event"
import get from "lodash/get"
import { UPDATE_EVENT_STATUS } from "../actions/types"

import {
  updateStatusError,
  requestTransitionListSuccess,
} from "../actions/creators"

const { REACT_APP_API_URL } = env

function* request(action) {
  const { event, newStatusCode, data, status } = action.config
  try {
    // Запрос на изменение статуса
    yield call(authRequest, {
      url: `${REACT_APP_API_URL}/events/status`,
      method: `post`,
      data: {
        eventUuid: event,
        statusCode: newStatusCode,
      },
    })
    // Запрашиваем новый список переходов для статусов
    const transitions = yield call(authRequest, {
      url: `${REACT_APP_API_URL}/events/${event}/transitions`,
    })
    // Сохраняем новый список переходов
    yield put(requestTransitionListSuccess(transitions))
    // Обновляем статув в текущем событии
    yield put(
      creators.update.success(eventModel, event, {
        ...data,
        status,
        restrictions: status.restrictions,
      }),
    )
    yield call(showToast, {
      type: `success`,
      message: `Статус успешно изменен.`,
      hideIn: 5,
    })
  } catch (error) {
    yield put(updateStatusError(error))
    yield call(showToast, {
      type: `error`,
      message: get(error, `response.data.exception`),
      hideIn: 5,
    })
  }
}

export default function* updateSaga() {
  while (true) {
    const action = yield take(UPDATE_EVENT_STATUS)
    yield fork(request, action)
  }
}
